<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
  export default {
    name: "DoomyView"
  }
</script>

<style scoped>

</style>